import React, { useState, useRef } from 'react';
import CheckBox from './../../../UI/CheckBox';

const Further1 = ({
  questArr,
  onselectAnswer,
  optionSelected76,
  className,
  qnNo,
  addPending
}) => {
  const [showError, setshowError] = useState("hide");
  const checkboxRefs = useRef({});

  const labelclicked = async (e) => {
    let selectedCount = optionSelected76.length;
    if (selectedCount == 0) {
      setshowError("show");
    } else {
      onselectAnswer(e);
    }
  };

  const onSelectOption = (e) => {
    if (e.target.checked === true) {
      setshowError("hide");
      optionSelected76.push({ id: +e.target.value });
      // checkBoxDisable(e.target.value);
    } else {
      let deselect = e.target.value;
      const decre = optionSelected76.map((OptionArray, index) => {
        if (deselect == OptionArray.id) {
          optionSelected76.splice(index, 1);
        }
        if (optionSelected76.length == 0) {
          checkBoxEnable();
        }
      });
    }
  };

  let checkArray = questArr.answers;
  const lenderCheckBox = checkArray.map((checArr, index) => {
    return (
      <li className="adjustbalewidfull" key={checArr.value}>
        <div className='optionbtn2' ref={(e) => checkboxRefs.current[checArr.value] = e}>
          <CheckBox
            dataId={`confirmSituation${checArr.value}`}
            name="further1[]"
            onChange={onSelectOption}
            className=""
            CheckBoxText={'<span></span>'+checArr.label}
            value={checArr.value}
            labelClassName="tick-check-box"
          />
        </div>
      </li>
    );
  });

  const checkBoxDisable = (checkBoxId) => {
    if (checkBoxId != 225) {
      checkArray.map((checArr, index) => {
        checkboxRefs.current[checArr.value].childNodes[0].disabled = false;
        checkboxRefs.current[checArr.value].childNodes[1].classList.remove("disabledcheckbox");
      })
      checkboxRefs.current[225].childNodes[0].disabled = true;
      checkboxRefs.current[225].childNodes[1].classList.add("disabledcheckbox");
    } else if (checkBoxId == 225) {
      checkArray.map((checArr, index) => {
        checkboxRefs.current[checArr.value].childNodes[0].disabled = true;
        checkboxRefs.current[checArr.value].childNodes[1].classList.add("disabledcheckbox");
      })
      checkboxRefs.current[225].childNodes[0].disabled = false;
      checkboxRefs.current[225].childNodes[1].classList.remove("disabledcheckbox");
    }
  }

  const checkBoxEnable = () => {
    checkArray.map((checArr, index) => {
      checkboxRefs.current[checArr.value].childNodes[0].disabled = false;
      checkboxRefs.current[checArr.value].childNodes[1].classList.remove("disabledcheckbox");
    })
  }

  return (
    <>
      <div className={`container ${className}`}>
        <div className="questitem mt-5">
          <h1 className="que-title p-3"><b>At the time you secured your finance with Vanquis</b>, which of the below statements accurately describe your situation</h1>
          <div className="question-content mt-0 scale-down-ver-center px-3 py-lg-3 py-md-3 py-sm-2 py-2">
            <div className="row">
              <div className="col-lg-12 mb-2">
                <ul className="p-0 m-0 option-grid">
                  {lenderCheckBox}
                </ul>
              </div>
              <div className="col-lg-12 mb-2 mt-2">
                <span className={`error_msg ${showError}`} id="email_err">
                  Please select at least one
                </span>
                <button
                  className="qb3 btn-comm2 py-lg-3 py-md-3 py-sm-2 py-2 w-100 nextBtn"
                  name="question_76"
                  type="button"
                  id="nextscroll"
                  data-quest-id={76}
                  onClick={labelclicked}
                  data-click-id='further76_next'
                >
                  Next &#8594; </button>
              </div>
            </div>
            <p className="text-center bck-marwid">
              <button name="struggle" 
              className="btn btn-secondary backbtn1a" 
              id="" 
              value=""
              onClick={()=>addPending("chooseLender")}
              type="button"
              data-click-id='further76_back'
              >Go Back
              </button>
            </p>
          </div>
        </div>
        <div className="tipbox tip2 show">
          Your feedbacks helps support the basis of claims.
          <div className="arrow  arrow-top"></div>
        </div>
        <div
          id="rangequestions"
          class="qrange d-flex align-items-sm-center text-center"
        >
          Question <br class="d-none d-md-block" />
          {qnNo}
        </div>
      </div>
    </>
  )
}

export default Further1;